"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_DETAILS_MINI_SHADE = exports.PRODUCT_DETAILS = void 0;
const PRODUCT_DETAILS = exports.PRODUCT_DETAILS = 'product-details';
const PRODUCT_DETAILS_MINI_SHADE = exports.PRODUCT_DETAILS_MINI_SHADE = 'product-details-mini-shade';
